import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CFormInputWithMaskPhone } from "src/components/Masks/Masks";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
  CFormInput,
} from "@coreui/react";
import {
  Checkbox,
  DatePicker,
  Flex,
  Input,
  message,
  Select,
  Typography,
} from "antd";
import { getClubs } from "src/store/Slices/DropDownSlice";

export const GetClientsReport = ({
  birthdayFrom,
  birthdayTo,
  commentModal,
  clubId,
  phoneNumber,
  email,
  clientF,
  clientI,
  clientO,
  idFrom,
  idTo,
  setBirthdayFrom,
  setBirthdayTo,
  setCommentModal,
  setClubId,
  setPhoneNumber,
  setEmail,
  setClientF,
  setClientI,
  setClientO,
  setIdFrom,
  setIdTo,
  clubs,
  onClickGetReport,
}) => {
  const dispatch = useDispatch();
  console.log(phoneNumber);
  return (
    <CModal
      alignment="center"
      visible={commentModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setCommentModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">{"Отчёт"}</CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Даты рождения с</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setBirthdayFrom(date);
                }}
                value={birthdayFrom}
              />
            </div>
            <div>
              <Typography.Title level={5}>По</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"YYYY-MM-DD"}
                placement={"topRight"}
                onChange={(date) => {
                  setBirthdayTo(date);
                }}
                value={birthdayTo}
              />
            </div>
            <div>
              <Typography.Title level={5}>Клуб</Typography.Title>
              <Select
                style={{ width: "100%" }}
                placeholder="Выбрать"
                onClick={() => {
                  dispatch(getClubs());
                }}
                value={clubId}
                onChange={(e) => {
                  setClubId(e);
                }}
                options={clubs?.data?.value}
              />
            </div>
            <div>
              <Typography.Title level={5}>Номер телефона</Typography.Title>
              <CFormInput
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Почта</Typography.Title>
              <CFormInput
                value={email}
                onChange={(e) => {
                  setEmail(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Фамилия</Typography.Title>
              <CFormInput
                value={clientF}
                onChange={(e) => {
                  setClientF(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Имя</Typography.Title>
              <CFormInput
                value={clientI}
                onChange={(e) => {
                  setClientI(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Отчество</Typography.Title>
              <CFormInput
                value={clientO}
                onChange={(e) => {
                  setClientO(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Айди с</Typography.Title>
              <CFormInput
                value={idFrom}
                onChange={(e) => {
                  setIdFrom(e.currentTarget.value);
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>По</Typography.Title>
              <CFormInput
                value={idTo}
                onChange={(e) => {
                  setIdTo(e.currentTarget.value);
                }}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setCommentModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickGetReport} style={{ color: "#fff" }}>
          Получить отчёт
        </CButton>
      </CModalFooter>
    </CModal>
  );
};
